import React, { FC } from 'react'
import clsx from 'clsx'

import styles from '../Navbar.module.scss'
import { StandardProps } from '../../../types/common'

interface NavCtaProps extends StandardProps {
  href?: string
  tag?: 'a' | 'span'
  icon?: React.ReactNode
  onClick?: () => void
}

export const NavCta: FC<NavCtaProps> = ({
  children,
  className,
  href = '#',
  tag: Tag = 'a',
  icon,
  style,
  onClick,
  testid = 'nav-cta',
  ...props
}) => {
  return (
    <Tag
      {...props}
      href={href}
      className={clsx(styles['hds-nav__cta'], className)}
      style={style}
      onClick={onClick}
      data-testid={testid}
    >
      {children}
      {icon && <div className={styles['hds-nav__cta_icon']}>{icon}</div>}
    </Tag>
  )
}
